import React from 'react';
import { MetadataField, getMetadataFieldName } from '@models/prediction';
import { ConfigSection } from '@components/config/ConfigSection';
import RadioButtonList, { RadioButtonEntry } from '@components/config/radioButtonsList';

export interface ConfigMetadataProps {
    metadataFieldList: MetadataField[];
    value?: MetadataField;
    onChange: (value?: MetadataField) => void;
}

const MetadataFieldSection: React.FC<ConfigMetadataProps> = ({
    metadataFieldList,
    value: selectedMetadataField,
    onChange,
}) => {
    const metadataRadioButtonList: RadioButtonEntry<MetadataField>[] = metadataFieldList.map(
        (field) => {
            return { value: field, label: getMetadataFieldName(field) };
        },
    );
    const onMetadataChange = (element: MetadataField) =>
        onChange(element === selectedMetadataField ? undefined : element);

    return (
        <ConfigSection title="Metadata" data-qa="metadata-config-section">
            <RadioButtonList
                list={metadataRadioButtonList}
                selectedValue={selectedMetadataField}
                onChange={onMetadataChange}
            />
        </ConfigSection>
    );
};

export default MetadataFieldSection;
